module.exports = __webpack_public_path__ + "static/img/logo_and_brand.530f57c4.png";